<template>
    <div class="animated fadeIn">
        <div class="app-contentHeader">
            <a
                class="kgr-button kgr-button--link"
                @click="onBack"
            >
                <kgr-icon
                    icon-class="arrow-left"
                    class="kgr-button__icon kgr-button__icon--left"
                />
                <span v-t="'backToOverview'"></span>
            </a>

            <kgr-button
                v-if="withPrimaryButtons"
                :value="$t('save')"
                :pending="pending"
                :disabled="disabled"
                @click="onCreate"
            />
        </div>

        <slot></slot>

        <div
            v-if="withPrimaryButtons"
            class="actions clearfix"
        >
            <kgr-button
                :value="$t('cancel')"
                type="grey"
                @click="onCancel"
            />

            <kgr-button
                :value="$t('save')"
                class="right"
                :pending="pending"
                :disabled="disabled"
                @click="onCreate"
            />
        </div>
    </div>
</template>

<script>
import Icon from '../../common/icon/Icon';
import KgrButton from '../../common/form/button/KgrButton';

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-button': KgrButton,
    },
    props: {
        pending: {
            type: Boolean,
            required: false,
        },
        withPrimaryButtons: {
            type: Boolean,
            required: false,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        onCreate() {
            this.$emit('primaryBtnClicked');
        },
        onBack() {
            this.$emit('backBtnClicked');
        },
        onCancel() {
            this.$emit('cancelBtnClicked');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .delete {
    margin-right: 5px;
}
button.right {
    float: right;
}
</style>
